import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "./ui/button";
import { UserCog, ArrowLeft } from "lucide-react";

export default function ImpersonationBanner() {
  const { user, refresh } = useAuth();
  const navigate = useNavigate();

  if (!user || typeof user !== "object" || !user.impersonating) return null;

  const stop = async () => {
    try {
      await api.post("/admin/stop-impersonate");
      await refresh();
      toast.success("Voltou para a conta de admin");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  return (
    <div
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[60] flex items-center gap-3 px-4 py-2 rounded-full border border-amber-500/50 bg-black/85 text-amber-400 shadow-xl backdrop-blur"
      data-testid="impersonation-banner"
    >
      <UserCog className="h-4 w-4 shrink-0" />
      <div className="text-xs sm:text-sm">
        Visualizando como <b className="text-white">{user.name}</b>
      </div>
      <Button
        size="sm"
        variant="outline"
        onClick={stop}
        className="h-7 border-amber-500/60 text-amber-400 hover:bg-amber-500/10"
        data-testid="stop-impersonate-btn"
      >
        <ArrowLeft className="h-3 w-3 mr-1" /> Voltar como Admin
      </Button>
    </div>
  );
}
